import React from 'react'
import Link from '../link'

const Button = (props) => {
  return (
    <Link { ...props } className={ props.className || "btn btn-primary" } />
  )
}

export default Button



// WEBPACK FOOTER //
// ./app/javascript/app/site/components/content/rich_text/button/index.js